const generateEmailShareLink = (urlToShare, invitationMessage) =>
  `mailto:?body=${encodeURIComponent(invitationMessage)}%20${encodeURIComponent(urlToShare)}`;

export default generateEmailShareLink;
